<aims-common-table id="department-table" [dataSource]="departments | async" [header]="departmentsHeader" [pageSize]="10"
    [permissions]="tablePermissions" [addRowInitialObject]="initialTableElement" (rowUpdated)="handleRowUpdate($event)"
    (rowAdded)="handleRowAdd($event)">

    <aims-common-table-dynamic-row id="managerId">
        <ng-template viewMode let-element>{{ element.managerId | getText:'employeeId':'fullName':managerValues |
            async}}
        </ng-template>
        <ng-template editMode let-element let-idx="idx" let-dynamicControl="dynamicControl">
            <mat-form-field appearance="fill" class="top10 fullWidth">
                <mat-label>Department Manager</mat-label>
                <mat-select [formControl]="dynamicControl">
                    <mat-option label=""></mat-option>
                    <mat-option *ngFor="let val of managerValues | async" [value]="val.employeeId">
                        {{val.fullName}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-template>
        <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
            <mat-form-field appearance="fill" class="top20 fullWidth">
                <mat-label>Filter</mat-label>
                <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                    <mat-option label=""></mat-option>
                    <mat-option *ngFor="let val of managerValues | async" [value]="val.employeeId">
                        {{val.fullName}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-template>
    </aims-common-table-dynamic-row>

    <ng-template aimsCommonTableExpandedRow let-element>
          <mat-card style="margin-left: 10px;">
                <aims-common-table label="Work Sections"
                    [id]="'workSections-in-table-' + element.workSectionId"
                    [dataSource]="workSectionsResults | filter:'departmentId':element.departmentId"
                    [header]="workSectionsHeader" [pageSize]="5" [permissions]="tablePermissions"
                    [addRowInitialObject]="initialWorkSectionTableElement"
                    (rowUpdated)="handleWorkSectionRowUpdate($event)" (rowAdded)="handleWorkSectionRowAdd($event)">

                    <aims-common-table-dynamic-row id="departmentId">
                        <ng-template viewMode let-element>{{ element.departmentId |
                            getText:'departmentId':'department':departmentValues |
                            async}}
                        </ng-template>
                        <ng-template editMode let-element let-idx="idx" let-dynamicControl="dynamicControl">
                            <mat-form-field appearance="fill" class="top10 fullWidth">
                                <mat-label>Department</mat-label>
                                <mat-select [formControl]="dynamicControl">
                                    <mat-option label=""></mat-option>
                                    <mat-option *ngFor="let val of departmentValues | async" [value]="val.departmentId">
                                        {{val.department}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </ng-template>
                        <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
                            <mat-form-field appearance="fill" class="top20 fullWidth">
                                <mat-label>Filter</mat-label>
                                <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                                    <mat-option label=""></mat-option>
                                    <mat-option *ngFor="let val of departmentValues | async" [value]="val.departmentId">
                                        {{val.department}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </ng-template>
                    </aims-common-table-dynamic-row>

                    <aims-common-table-dynamic-row id="leadId">
                        <ng-template viewMode let-element>{{ element.leadId | getText:'employeeId':'fullName':leadValues
                            |
                            async}}
                        </ng-template>
                        <ng-template editMode let-element let-idx="idx" let-dynamicControl="dynamicControl">
                            <mat-form-field appearance="fill" class="top10 fullWidth">
                                <mat-label>Work Section Lead</mat-label>
                                <mat-select [formControl]="dynamicControl">
                                    <mat-option label=""></mat-option>
                                    <mat-option *ngFor="let val of leadValues | async" [value]="val.employeeId">
                                        {{val.fullName}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </ng-template>
                        <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
                            <mat-form-field appearance="fill" class="top20 fullWidth">
                                <mat-label>Filter</mat-label>
                                <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                                    <mat-option label=""></mat-option>
                                    <mat-option *ngFor="let val of leadValues | async" [value]="val.employeeId">
                                        {{val.fullName}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </ng-template>
                    </aims-common-table-dynamic-row>
                </aims-common-table>
              </mat-card>
    </ng-template>

</aims-common-table>
